import React, { useState } from "react";
import PropTypes from "prop-types";

//
import { Card } from "react-bootstrap";
import NumberFormat from "react-number-format";

//
import { iconImage } from "../../../redux/features/coins/actions";
import { getCoinAdditionalInfo } from "../../../redux/features/coins/actions";

//
import PieChart from "../../general/PieChart";
import BoxLoading from "../../general/BoxLoading";
import ProgressChart from "../../general/ProgressChart";
import AdditionalModal from "../AdditionalModal";
import ImageBox from "../../general/ImageBox";

function CoinInfo({ data, chart, loading }) {
  const [boxLoading, setBoxLoading] = useState(false);
  const [showAdditionalModal, setShowAdditionalModal] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState(null);

  /**
   * Convert Data
   * for split and return splited
   */
  const convertValue = (value) => {
    let str = `${value}`;
    let splited = str.split(".");

    return (
      <h4>
        <NumberFormat
          value={splited[0]}
          displayType={"text"}
          prefix={data.symbol === "BTC" ? "$" : "₿"}
          thousandSeparator={true}
          decimalSeparator="."
        />

        {splited[1] && <span>.{splited[1]}</span>}
      </h4>
    );
  };

  /**
   * Get Coin Additional Information
   */
  const get_coin_info = async () => {
    // start loading
    setBoxLoading(true);

    // set variable
    let symbol = data.symbol;

    // request
    await getCoinAdditionalInfo(symbol).then((res) => {
      if (res) {
        setAdditionalInfo(res);
        setShowAdditionalModal(true);
      }
    });

    // stop loading
    setBoxLoading(false);
  };

  return (
    <Card className="h-100 mb-0">
      <Card.Body className="pb-0">
        <div>
          <p className="pair">
            <ImageBox src={iconImage(data.symbol)} />
            <div>
              <span className="text-dark fw-bolder">{data.symbol}</span>
              <i className="las la-sync" />
              <span className="text-dark fw-bolder">
                {data.symbol === "BTC" ? "USD" : "BTC"}
              </span>
            </div>
          </p>

          <div className="price-box">
            <div className="price">
              {convertValue(
                Number(data.price)
                  .toFixed(data.symbol === "BTC" ? 2 : 8)
                  .replace(/\.?0+$/, "")
              )}
              <span
                className={`fw-extra-bolder ${
                  data.percent_change_24h > 0 ? "text-success" : "text-danger"
                }`}
              >
                {data.percent_change_24h.toFixed(2)}
                <i
                  className={`las la-arrow-${
                    data.percent_change_24h > 0 ? "up" : "right"
                  }`}
                />
              </span>
            </div>

            <small>
              <NumberFormat
                value={data.total_supply}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator="."
                className="me-1"
              />
              {data.symbol}
            </small>
          </div>

          <ProgressChart
            low={Number(data.low)
              .toFixed(data.symbol === "BTC" ? 2 : 8)
              .replace(/\.?0+$/, "")}
            high={Number(data.high)
              .toFixed(data.symbol === "BTC" ? 2 : 8)
              .replace(/\.?0+$/, "")}
            close={Number(data.close)
              .toFixed(data.symbol === "BTC" ? 2 : 8)
              .replace(/\.?0+$/, "")}
            symbol={data.symbol}
          />
        </div>

        <div>
          <div className="market-info">
            <div className="item">
              <small>Market Cap</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={data.market_cap}
                  displayType={"text"}
                  prefix="$"
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
            <div className="item">
              <small>24 Hour Trading Volume</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={data.volume_24h}
                  displayType={"text"}
                  prefix="$"
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
            <div className="item">
              <small>Full Diluted Valuation</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={data.volume}
                  displayType={"text"}
                  prefix="$"
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
            <div className="item">
              <small>Circulating Supply</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={data.circulating_supply}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
            <div className="item">
              <small>Total Supply</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={data.total_supply}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>

            <div className="item">
              <small>Max Supply</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={data.max_supply}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
          </div>

          <small
            className="text-info fw-bolder pointer modal-btn"
            onClick={() => get_coin_info()}
          >
            Additional Information...
          </small>

          {additionalInfo && (
            <AdditionalModal
              show={showAdditionalModal}
              setShow={(state) => setShowAdditionalModal(state)}
              data={additionalInfo}
            />
          )}

          <PieChart
            chartOprions={chart.action}
            title="Coin Actions"
            infoText="Action"
            total
          />
        </div>
      </Card.Body>

      {(loading || boxLoading) && <BoxLoading />}
    </Card>
  );
}

CoinInfo.propTypes = {
  data: PropTypes.object.isRequired,
  chart: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default CoinInfo;
